import { render, staticRenderFns } from "./IndicatorPlugin.vue?vue&type=template&id=9bdd91d2&scoped=true"
import script from "./IndicatorPlugin.vue?vue&type=script&lang=ts"
export * from "./IndicatorPlugin.vue?vue&type=script&lang=ts"
import style0 from "./IndicatorPlugin.vue?vue&type=style&index=0&id=9bdd91d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdd91d2",
  null
  
)

export default component.exports